import React from "react";
import styled, {css} from "styled-components";

interface LayoutProps {
    isMainPage: boolean
}

export const Layout = styled.div.attrs<LayoutProps>(({isMainPage, theme}) => {
    return {
        //style: {background: "url('back2.png'), #F7F4F5"}
        //style: {background: isMainPage ? "url('back2.png'), #F7F4F5" : theme.colors.primaryBackground}
    }
})<LayoutProps>`
  position: relative;
  min-height: 100%;
  width: 100%;

  ${({theme}) => css`background: ${theme.colors.primaryBackground}`};
  color: ${({theme}) => theme.colors.primaryFont};
`

export const Content = styled.main`
  padding-bottom: 350px;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding-bottom: 400px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    padding-bottom: 150px;
  }
`